const mySlider = document.querySelector('.my-slider');
if (mySlider) {
  const swiper = new Swiper('.my-slider', {
    loop: true,
    speed: 1000,
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.swiper-pagination',
      // bulletClass: '.swiper-pagination-bullet',
      // bulletActiveClass: '.swiper-pagination-bullet-active',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      780: {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },
    },
  });
}
